module.exports = __webpack_public_path__ + "static/media/6.04fa545e.png";